module.exports = __webpack_public_path__ + "static/wiczlino2-a4d812fbe9d3386fa7b59442a04cfe81.jpg";